/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Box, Typography, WithStyles } from '@material-ui/core';
import { generateStyle } from '../../utils/styles';
import Style from './style';
import { useLocation } from 'react-router-dom';
//import useStyles from './style';
//import Style from './style';
//import { RootState } from '../../reducers';


export interface Props extends WithStyles<typeof Style> {
	[name: string]: any;
}
/**
 *
 */

 const Page404: React.FC<Props> = ({classes,name }: Props) => {
//	const classes = useStyles();
	const location  =useLocation();
	if(location.pathname.includes("error")){
		return (
			<Box className={classes.root}>
			<Typography className={classes.errorTitle}>400</Typography>
			<Typography className={classes.errorMessage}>
			Thats an error. Please try navigating to the home page again
			</Typography>
		</Box>
		)
	}
	return (
		<Box className={classes.root}>
				<Typography className={classes.errorTitle}>404</Typography>
				<Typography className={classes.errorMessage}>
					The page you have requested does not exist or is unavailable .
				</Typography>
			</Box>
	);
};

export default generateStyle(Style, 'Page404')(Page404);